import React from "react";
import DetailClientsReceiptsLayout from "./detail-clients-receipts-layout";

export default class DetailClientReceipts extends React.Component<{}, {}> {
  render() {
    return <DetailClientsReceiptsLayout />;
  }
}
